import { type AgentsClientInterface } from './agentsClient.types';
import CorporateAgentsClient from './corporateAgentsClient';
import GroupAgentsClient from './groupAgentsClient';
import type { ClientContext } from '~/services/contextClient';

export default class AgentsClientFactory {
    static createClient(context: ClientContext): AgentsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateAgentsClient(context.teamId);
        } else if (context.groupId) {
            return new GroupAgentsClient(context.teamId, context.groupId);
        }

        throw new Error('Invalid context for agents client');
    }
}
